import store from '@/store'
import { CLEAR, INIT, SET_LOADING_STATUS, SET_STATUS_MESSAGE, SPLICE, SET_TOTAL_COUNT } from './mutation-types'

const state = {
  interests: [],
  totalCount: 0,
  status: {
    loading: false,
    message: 'Loading'
  }
}

const getters = {
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getAllInterests: (state) => {
    return state.interests
  },
  getTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  async init ({ commit }, { newInterests, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_TOTAL_COUNT, { val: totalCount })
      commit(INIT, { newInterests, totalCount: isFullArraySize ? totalCount : newInterests.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async next ({ commit }, { newInterests, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE, { newInterests, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  async clear ({ commit }) {
    commit(CLEAR)
  },
  setTotalCount ({ commit }, { val }) {
    commit(SET_TOTAL_COUNT, { val })
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [INIT] (state, { newInterests, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newInterests))
    state.interests = new Array(totalCount)
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'interestContacts',
        params: { interestId: obj.id },
        query: { interestName: obj.name }
      }
      return obj
    })
    state.interests.splice(0, objs.length, ...mappedObjs)
  },
  [SPLICE] (state, { newInterests, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newInterests))
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'interestContacts',
        params: { interestId: obj.id },
        query: { interestName: obj.name }
      }
      return obj
    })
    state.interests.splice(startIndex, objs.length, ...mappedObjs)
  },
  [SET_TOTAL_COUNT] (state, { val }) {
    state.totalCount = val
  },
  [CLEAR] (state) {
    state.interests = []
    state.status = {
      loading: false,
      message: 'Loading Interests. Please wait...'
    }
    state.totalCount = 0
  }
}

export const interestMapActions = {
  initInterests: 'interest/init',
  appendInterests: 'interest/next',
  clearInterests: 'interest/clear'
}

export const interest = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
